export default __webpack_public_path__ + "static/media/icon.86e3de94.png";